import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import enCommon from '../../locales/en/common.json'
import frCommon from '../../locales/fr/common.json'

// the translations
const resources = {
  en: {
    common: enCommon,
    translation: enCommon, // Fallback for components using the default namespace
  },
  fr: {
    common: frCommon,
    translation: frCommon, // Fallback for components using the default namespace
  },
}

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    fallbackNS: 'common',
    ns: ['common', 'translation'],
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
